import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faChevronDown, faChevronUp, faFileLines, faTriangleExclamation} from '@fortawesome/pro-solid-svg-icons';
import {BicButtonComponent} from '@buildinginformationcloud/bic-ui-components';

/**
 * Fehler-Anzeige bei fehlgeschlagenem Workflow.
 * Zeigt eine Fehlermeldung mit optionalen Details und Aktions-Buttons.
 */
@Component({
  selector: 'my-checks-error',
  standalone: true,
  imports: [FontAwesomeModule, BicButtonComponent],
  templateUrl: './check-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./check-error.component.scss'],
})
export class CheckErrorComponent {
  @Input() error = '';
  @Input() details = '';
  /** Whether the "Logs anzeigen" button should be shown (i.e. an execution instance with logs exists). */
  @Input() canViewLogs = false;
  @Output() retry = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();
  @Output() viewLogs = new EventEmitter<void>();

  readonly faTriangleExclamation = faTriangleExclamation;
  readonly faChevronDown = faChevronDown;
  readonly faChevronUp = faChevronUp;
  readonly faFileLines = faFileLines;

  detailsExpanded = false;

  toggleDetails(): void {
    this.detailsExpanded = !this.detailsExpanded;
  }
}
